import { Undo2, Redo2, ZoomIn, ZoomOut, ScanEye } from 'lucide-react';

/**
 * @param {{
 *   onUndo?: () => void;
 *   onRedo?: () => void;
 *   onZoomIn?: () => void;
 *   onZoomOut?: () => void;
 *   onFit?: () => void;
 *   canUndo?: boolean;
 *   canRedo?: boolean;
 * }} props
 */
function CanvasToolbar({
  onUndo,
  onRedo,
  onZoomIn,
  onZoomOut,
  onFit,
  canUndo = false,
  canRedo = false,
}) {
  return (
    <div className="floor-plan-workspace-toolbar card" role="toolbar" aria-label="Canvas actions">
      <button
        type="button"
        className="floor-plan-workspace-toolbar-btn"
        onClick={onUndo}
        disabled={!canUndo}
        title="Undo"
        aria-label="Undo"
      >
        <Undo2 size={18} aria-hidden />
      </button>
      <button
        type="button"
        className="floor-plan-workspace-toolbar-btn"
        onClick={onRedo}
        disabled={!canRedo}
        title="Redo"
        aria-label="Redo"
      >
        <Redo2 size={18} aria-hidden />
      </button>
      <button
        type="button"
        className="floor-plan-workspace-toolbar-btn"
        onClick={onZoomIn}
        title="Zoom in"
        aria-label="Zoom in"
      >
        <ZoomIn size={18} aria-hidden />
      </button>
      <button
        type="button"
        className="floor-plan-workspace-toolbar-btn"
        onClick={onZoomOut}
        title="Zoom out"
        aria-label="Zoom out"
      >
        <ZoomOut size={18} aria-hidden />
      </button>
      <button
        type="button"
        className="floor-plan-workspace-toolbar-btn"
        onClick={onFit}
        title="Fit to screen"
        aria-label="Fit to screen"
      >
        <ScanEye size={18} aria-hidden />
      </button>
    </div>
  );
}

export default CanvasToolbar;
